import { renderImage } from "./image";
import { renderVideo } from "./video";
export const initBanner = (option, play, pause) => {
    const banner = document.createElement("div");
    banner.style.display = "flex";
    banner.style.justifyContent = "center";
    banner.style.alignItems = "center";
    const mime = option.mime.includes("image")
        ? "image"
        : option.mime.includes("video")
            ? "video"
            : "";
    switch (mime) {
        case "image":
            const image = renderImage(option, play, pause);
            image.style.width = "auto";
            image.style.height = "auto";
            image.style.maxWidth = "100%";
            image.style.maxHeight = "100%";
            banner.appendChild(image);
            break;
        case "video":
            const video = renderVideo(option, play, pause);
            banner.appendChild(video);
            break;
        default:
            return document.createElement("div");
    }
    return banner;
};
//# sourceMappingURL=banner.js.map